import useHttpProvider from "@/common/hooks/use-http";
import { useIsMobile } from "@/common/hooks/use-mobile";
import { useCallback, useEffect, useMemo, useState } from "react";
import CurrentPromotion from "../components/current-promotion";
import { GiveawayType, Promotion } from "../models/giveaway";
import * as GiveawaysService from "../services/giveaways";

function CurrentPromotions() {
	const { http } = useHttpProvider();
	const isMobile = useIsMobile();
	const [currentPromotions, setCurrentPromotions] = useState<Promotion[]>([]);

	const getCurrentPromotions = useCallback(async () => {
		const response = await GiveawaysService.getActivePromotions(http);
		setCurrentPromotions(response);
	}, [http]);

	const orderedPromotions = useMemo(() => {
		if (!isMobile) return currentPromotions;
		const monthly = currentPromotions.filter(
			(p) => p.type === GiveawayType.monthly
		);
		const weekly = currentPromotions.filter(
			(p) => p.type === GiveawayType.weekly
		);
		return [...monthly, ...weekly];
	}, [currentPromotions, isMobile]);

	useEffect(() => {
		getCurrentPromotions();
	}, [getCurrentPromotions]);

	if (currentPromotions.length === 0) {
		return (
			<div className="flex flex-col items-center justify-center px-4 py-16 md:px-37 md:py-50">
				<span className="web-heading-h2 mb-4 text-center">
					No Current Promotions
				</span>
				<p className="text-center text-gray-500">
					Please check back later for exciting new promotions!
				</p>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-16 px-4 py-16 md:px-37 md:py-50">
			<span className="web-heading-h2 text-center">
				Current{" "}
				<span
					style={{
						background:
							"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
						WebkitBackgroundClip: "text",
						backgroundClip: "text",
						WebkitTextFillColor: "transparent",
					}}
				>
					Promotions
				</span>
			</span>
			<div className="flex flex-col gap-16 overflow-y-scroll md:max-h-[1200px] md:min-h-300">
				{orderedPromotions.map((promotion, index) => (
					<CurrentPromotion promotion={promotion} key={index} />
				))}
			</div>
		</div>
	);
}

export default CurrentPromotions;
